/**
 * 竞品包名把内部编号挂在最后的括号里，例如 (MJZKAW)。
 * 只拿掉末尾那一个括号：名字前面或中间的括号可能是名字本身，比如颜文字 (ˊᵒ̴̶̷̤ ꇴ ᵒ̴̶̷̤ˋ)。
 * 只在从文件名生成名字时调用；运营改过的名字原样保存，否则每存一次就会再削掉一个括号。
 */

export function withoutTrailingKey(name) {
  const source = String(name || '').trim()
  const cleaned = source.replace(/\s*[（(][^（）()]*[）)]$/, '').trim()
  return cleaned || source
}

export function stickerNameFromFile(fileName) {
  const base = String(fileName || '').replace(/\.[^./\\]+$/, '')
  return withoutTrailingKey(base)
}
